"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SixCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SixCircleLinear = function SixCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#SixCircleLinear_svg__SixCircleLinear_svg__paint0_linear_16923_92059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.053 19.267v2.234h-.484c-2.05.038-3.68.645-4.895 1.822-1.215 1.176-1.916 2.831-2.106 4.966 1.09-1.252 2.58-1.879 4.468-1.879 1.802 0 3.24.636 4.312 1.907 1.081 1.271 1.622 2.913 1.622 4.924 0 2.134-.584 3.842-1.75 5.123-1.158 1.28-2.714 1.92-4.668 1.92-1.982 0-3.59-.758-4.824-2.276-1.233-1.528-1.85-3.491-1.85-5.891v-1.01c0-3.814.811-6.727 2.434-8.738 1.631-2.02 4.055-3.055 7.271-3.102h.47zm-3.458 9.335a4.2 4.2 0 00-2.49.81c-.76.542-1.286 1.22-1.58 2.036v.968c0 1.707.384 3.083 1.153 4.126.768 1.044 1.726 1.565 2.874 1.565 1.186 0 2.116-.436 2.79-1.309.682-.873 1.024-2.016 1.024-3.43 0-1.422-.346-2.57-1.039-3.443-.683-.882-1.594-1.323-2.732-1.323z",
    fill: "url(#SixCircleLinear_svg__SixCircleLinear_svg__paint1_linear_16923_92059)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SixCircleLinear_svg__SixCircleLinear_svg__paint0_linear_16923_92059",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SixCircleLinear_svg__SixCircleLinear_svg__paint1_linear_16923_92059",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.SixCircleLinear = SixCircleLinear;
var _default = SixCircleLinear;
exports.default = _default;